import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=80cdbe74&scoped=true&lang=html&"
import script from "./Trip.vue?vue&type=script&lang=js&"
export * from "./Trip.vue?vue&type=script&lang=js&"
import style0 from "./Trip.vue?vue&type=style&index=0&id=80cdbe74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cdbe74",
  null
  
)

export default component.exports